'use client';

import { useWhitelabelContext } from 'context/whitelabel.context';
import { useEffect } from 'react';

export default function FaviconSetter() {
  const { lookAndFeel } = useWhitelabelContext();

  useEffect(() => {
    if (!lookAndFeel.favicon) return;
    let link = document.querySelector("link[rel='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = lookAndFeel.favicon;
  }, [lookAndFeel.favicon]);

  return null;
}
